import { Box } from '@mui/system'
import React from 'react'
//import image from '../images/logo-m.png'

const LogoMain = () => {
  return (
    <Box width='90%'>
      <img src={'./images/logo-m.png'} alt="Aerosim" width='100%' />
    </Box>
  )
}

export default LogoMain